import _toConsumableArray from "/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import levenshtein from 'fast-levenshtein';
var defaultAutoSuggestedDomains = ["gmail.com", "hotmail.com", "outlook.com", "live.com", "icloud.com", "yahoo.com.br", "yahoo.com", "bol.com.br", "uol.com.br", "terra.com.br", "aol.com"];
function useEmailField(_ref) {
  var emailDomainsSuggestions = _ref.emailDomainsSuggestions;
  var usedDomains = emailDomainsSuggestions || defaultAutoSuggestedDomains;
  function handleOptions(currentInputValue) {
    var _currentInputValue$sp = currentInputValue.split("@"),
      _currentInputValue$sp2 = _slicedToArray(_currentInputValue$sp, 2),
      idValue = _currentInputValue$sp2[0],
      domainValue = _currentInputValue$sp2[1];
    if (!!currentInputValue && typeof domainValue === "string" && domainValue === "") {
      return usedDomains.map(function (domain) {
        var suggestion = "".concat(idValue, "@").concat(domain);
        return {
          value: suggestion,
          label: suggestion
        };
      });
    }
    if (!domainValue || usedDomains.includes(domainValue)) {
      return [];
    }
    return usedDomains.reduce(function (acc, domain) {
      var distanceString = levenshtein.get(domain, domainValue);
      var isSimilar = distanceString <= 5 || domain.includes(domainValue);
      var suggestion = "".concat(idValue, "@").concat(domain);
      if (isSimilar || domainValue === "") return [].concat(_toConsumableArray(acc), [{
        value: suggestion,
        label: suggestion
      }]);
      return acc;
    }, []);
  }
  return {
    handleOptions: handleOptions
  };
}
export { useEmailField as default };